import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/invoices', request, cancelToken)
}

export {get}
